import { createSlice } from "@reduxjs/toolkit";
import { userManagementReducer } from "../extraReducers/userManagementReducer";

// 定义初始化数据
const initialState = {
  allUserInfoList: {} as any,
  userProfile: {} as any,
  money: {} as any,
  goldDetails: {} as any,
  silverDetails: {} as any,
  userFrindsList: {} as any,
  chantRecord: {} as any,
  userGroupList: {} as any,
  nextList: {} as any,
  groupChantRecord: {} as any,
  allGroupList: {} as any,
  groupManList: {} as any,
  avatar: {} as any,
  userBank: [] as any,
  userReportConfig: {} as any,
  fixReportStatus: {} as any,
  circleOffriendsConfig: {} as any,
  getGoldCoinConfig: {} as any,
  drawPeriodList: {} as any
};

const userManagementSlice = createSlice({
  name: "useManagement",
  initialState,
  reducers: {},
  extraReducers: userManagementReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default userManagementSlice.reducer;
